import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { getPartnerMaterialsDocs } from '../constants/partner-materials-docs.const';
import { PartnerBrandingService } from '../services/partner-branding.service';

export const partnerMaterialsGuard: CanActivateFn = () => {
  const partnerBranding = inject(PartnerBrandingService);
  const router = inject(Router);

  return toObservable(partnerBranding.partnerBrandingReady).pipe(
    filter((ready) => ready),
    take(1),
    map(() =>
      getPartnerMaterialsDocs(partnerBranding.partnerName())
        ? true
        : router.createUrlTree(['/dashboard']),
    ),
  );
};
